module.exports = __webpack_public_path__ + "static/media/Illus-Pickup_2@2x.31cc09f3.png";